<template>
  <BaseInput
    v-model="localValue"
    :placeholder="props.placeholder"
    :size="props.size"
    :tabindex="props.tabindex"
    :type="isPasswordType ? 'password' : 'text'"
  >
    <template #append-icon>
      <BaseIcon
        :name="isPasswordType ? 'vuesax:eye-slash' : 'vuesax:eye'"
        color="var(--color-foreground-primary)"
        size="20px"
        @click="isPasswordType = !isPasswordType"
      />
    </template>
  </BaseInput>
</template>

<script setup lang="ts">
import BaseIcon from '../icon/index.vue'
import BaseInput from '../input/index.vue'

interface Props {
  modelValue: string
  placeholder?: string
  tabindex?: number
  size?: 'md' | 'lg'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
})
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const isPasswordType = ref(true)
const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value: string) {
    emit('update:modelValue', value)
  },
})
</script>
